import React, { useState } from 'react'
import { Button } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { focusAtom, useSelector } from 'klyva'

import ColumnSettingsDialog from './column-settings-dialog'
import { BaseColumnEntry, ColumnSettingsAtom } from './types'

const ConfigureColumnsButton = <
  T extends string,
  U extends BaseColumnEntry<T>,
  BulkToggleKey extends string,
  OrderOptionKey extends string,
>({
  columnSettingsAtom,
  togglingDisabledColumns = new Set<T>(),
  headerText = 'Configure Columns',
}: {
  columnSettingsAtom: ColumnSettingsAtom<T, U, BulkToggleKey, OrderOptionKey>
  togglingDisabledColumns?: Set<T>
  headerText?: string
}) => {
  const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false)
  const numColumnsForToggles = useSelector(
    focusAtom(columnSettingsAtom, (o) => o.prop('columns').prop('length')),
    (numColumns) => {
      return Math.max(2, Math.ceil(numColumns / Math.max(1, 10)))
    },
  )
  return (
    <>
      <ColumnSettingsDialog<T, U, BulkToggleKey, OrderOptionKey>
        isOpen={isColumnSelectorOpen}
        onClose={() => setIsColumnSelectorOpen(false)}
        columnSettingsAtom={columnSettingsAtom}
        numColumnsForToggles={numColumnsForToggles}
        togglingDisabledColumns={togglingDisabledColumns}
        headerText={headerText}
      />
      <Tooltip2 content={headerText} hoverOpenDelay={1000}>
        <Button
          onClick={() => setIsColumnSelectorOpen(true)}
          icon="column-layout"
        />
      </Tooltip2>
    </>
  )
}

export default ConfigureColumnsButton
